var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
var site = site || {};

site.client = site.client || {};
site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.productStarterImageV2 = {
    textBadge: null,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;
      var $containers = $('.js-product-starter-image-v2', context);
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;
      var $thisProduct = $containers.closest('.js-product-full');
      var skuBaseId = $thisProduct.data('sku-base-id');
      var skuData = prodcat.data.getSku(skuBaseId);
      var productData = skuData ? prodcat.data.getProduct(skuData.PRODUCT_ID) : null;
      var productTextBadge = productData ? productData.MISC_FLAG_TEXT : null;
      var skuTextBadge = skuData ? skuData.MISC_FLAG_TEXT : null;
      self.textBadge = skuTextBadge || productTextBadge;

      self.attached = true;
      $containers.each(function () {
        var $container = $(this);
        var $carouselImages = $container.find('.js-product-starter-image__img-wrap--carousel');
        var $zoomImages = $container.find('.js-product-starter-image__img-wrap--zoomable');

        if (self.textBadge) {
          var $firstZoomImage = $zoomImages.find('.product-starter-image__img-wrap').first();
          var $firstSlide = $carouselImages.find('.product-starter-image__img-wrap').first();
          var $badge = $('<div>', {
            'class': 'product-starter-image__text-badge',
            'text': self.textBadge
          });
          $firstSlide.prepend($badge.clone());
          $firstZoomImage.prepend($badge);
        }

        if (isDesktop) {
          self.initZoom($container);
        } else {
          self.initMainImageCarousel($container);
        }

      });
    },
    initMainImageCarousel: function ($container, index) {
      var $imagesContainer = $('.js-product-starter-image-main', $container);

      index = index || 0;
      // Unslick the main image carousel
      $('.js-product-starter-image-main.slick-initialized', $container).unslick(
        '.js-product-starter-image-main'
      );
      // case for custom slides count and dots for mobile
      var settings = {
        rtl: site.direction.isRTL,
        infinite: true,
        mobileFirst: true,
        arrows: true,
        speed: 300,
        slide: '.product-starter-image__img-wrap, .js-video-block__media',
        initialSlide: index,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ],
      };
      // Init this carousel with our settings
      $imagesContainer.not('.slick-initialized').slick(settings);
      $imagesContainer.slickGoTo(index); // hack to set the active image of the slick slider.
    },
    initZoom: function ($container, index) {
      var $imgCollection = $('.js-product-starter-image-main', $container);
      var $imgContainer = $('.js-product-starter-image-grid', $container);
      var zoomLabel = $imgContainer.data('zoom-aria-label');
      var closeLabel = $imgContainer.data('zoom-close-aria-label');      
      var $mainImagesWrapper;
      var $newZoomIcon;
      var $zoomIcon;
      var scrollToHeight;
      index = index || 0;

      $mainImagesWrapper = $('.js-product-starter-image__img-wrap', $container);
      $zoomIcon = $('.js-product-starter-image-zoom-icon', $mainImagesWrapper);
      $zoomIcon.once().on('click keydown', function (e) {
        var eventType = e.type;
        var $this = $(this);

        if (e.key === 'Enter' || eventType === 'click') {
          $zoomIcon.toggleClass('close-icon');
          $mainImagesWrapper.add($imgContainer).toggleClass('img-zoom-view');
          scrollToHeight = $this.parents($mainImagesWrapper).offset().top;
          if (!($mainImagesWrapper.hasClass('img-zoom-view'))) {
            scrollToHeight = scrollToHeight - $('.js-site-header-formatter-v1').outerHeight(true);
            $zoomIcon.attr('aria-label', zoomLabel);
            // Analytics zoom close event
            if (site && site.track) {
              site.track.altImageZoomSelected({
                zoomAction: 'close',
                eventLabel: 'image_zoom_closed'
              });
            }
          } else {
            $zoomIcon.attr('aria-label', closeLabel);
            $imgCollection.css({ 'height': 'auto' });
            // Analytics zoom open event
            var productElem = $this.closest('.js-product-full');
            var imageElem = $this.closest('.js-product-starter-image__img-wrap').find('.js-product-starter-image-main-photo');

            if (site && site.track) {
              site.track.altImageZoomSelected({
                zoomAction: 'open',
                eventLabel: productElem.length > 0 ? $(productElem[0]).data('product-id') : '',
                imagePlacement: 'spp'
              });
            }
          }
          window.scrollTo({ top: scrollToHeight, behavior: 'smooth' });
          if (!$this.hasClass('close-icon') && eventType === 'click') {
            $this.blur();
          }
        }
      });
    },
    attached: false
  };
})(jQuery);
